// extracted by mini-css-extract-plugin
export var acitonButtons = "_gg-0";
export var additionalIcon = "_gg-f";
export var block = "_gg-1";
export var blockContent = "_gg-7";
export var blockDescription = "_gg-8";
export var blockIcon = "_gg-9";
export var blockTitle = "_gg-6";
export var border = "_gg-a";
export var center = "_gg-l";
export var edge = "_gg-b";
export var edgeLabel = "_gg-c";
export var edgePath = "_gg-d";
export var error = "_gg-e";
export var flowchart = "_gg-g";
export var flowchartContent = "_gg-h";
export var highlighted = "_gg-3";
export var hover = "_gg-4";
export var icon = "_gg-i";
export var left = "_gg-m";
export var navButton = "_gg-j";
export var navButtons = "_gg-k";
export var right = "_gg-n";
export var selected = "_gg-2";
export var small = "_gg-5";